import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
// import 'bootstrap/dist/css/bootstrap.css'
import React, { useEffect, useState } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import BasicMenu from "../../helpers/menu";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import {
  Badge,
  Chip,
  Dialog,
  Paper,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  TextField,
  Button,
} from "@mui/material";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory } from "react-router";
import AddForm from "../../helpers/AddForm";
import StatusLayout from "components/Status";

function EventManagement({
  location,
  SetSelectedMenu,
  resources,
  GetAllResources,
  FetchDetails,
}) {
  const [open, setOpen] = React.useState(0);
  const [value, setValue] = React.useState({});
  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [count, setCount] = React.useState(0);
  const [selected, setSelected] = React.useState(
    location.state?.status ?? "all"
  );
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [openDetails, setOpenDetails] = React.useState(false);
  const [info, setInfo] = React.useState(null);
  const [staffs, setStaffs] = React.useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dateFilterApplied, setDateFilterApplied] = useState(false);

  const history = useHistory();

  useEffect(() => {
    setSelected(location.state?.status ?? "all");
  }, [location.state]);

  useEffect(() => {
    SetSelectedMenu({
      menu: "product",
      title: "Product Management",
    });
    GetAllResources();
  }, []);

  const columns = [
    {
      name: "name",
      label: "Name",
    },
    {
      name: "startDate",
      label: "Start Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
      },
    },
    {
      name: "endDate",
      label: "End Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
      },
    },
    {
      name: "clientName",
      label: "Client",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "participants",
      label: "Participants",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (v) => v?.toLocaleString(),
      },
    },
    {
      name: "budget",
      label: "Budget",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (v) => v?.toLocaleString(),
      },
    },
    {
      name: "paymentStatus",
      label: "Payment Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (status) => {
          return <StatusLayout status={status} />;
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (status) => {
          let color =
            status === "active"
              ? "success"
              : status === "inactive"
              ? "error"
              : "info";
          return <StatusLayout status={status} />;
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <BasicMenu
            extra={[
              {
                label: "Document",
                onClick: () =>
                  history.push(`/admin/product/documents/${v}/eventId`),
              },
            ]}
            onDetails={() => {
              setId(v);
              setOpenDetails(true);
              const obj = list.find((vx) => vx.id === v);
              setInfo(obj);
            }}
            onDelete={() => {
              setDeleteOpen(true);
              setId(v);
            }}
            onEdit={() => {
              setOpen(2);
              const obj = list.find((vx) => vx.id === v);
              setId(v);
              setValue0("name", obj.name);
              setValue0(
                "startDate",
                moment(obj.startDate).format("YYYY-MM-DD")
              );
              setValue0("endDate", moment(obj.endDate).format("YYYY-MM-DD"));
              setValue0("clientName", obj.clientName);
              setValue0("participants", obj.participants);
              setValue0("paymentStatus", obj.paymentStatus);
              setValue0("budget", obj.budget);
              setValue0("status", obj.status);
            }}
          />
        ),
      },
    },
  ];
  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  const loadStaffs = async () => {
    const resp = await FetchDetails(`/api/event/staffs/${id}`);
    if (resp.status) {
      setStaffs(resp.data);
      setValue0(
        "staffs",
        resp.data?.map((v) => v.resourceId)
      );
    }
  };

  useEffect(() => {
    if (id) {
      loadStaffs().then();
    }
  }, [id]);

  const onSuccess = () => {
    setCount((v) => v + 1);
    setId(null);
  };

  // Handle date filter changes
  const handleFromDateChange = (e) => {
    setFromDate(e.target.value);
  };

  const handleToDateChange = (e) => {
    setToDate(e.target.value);

    if (fromDate && e.target.value) {
      setDateFilterApplied(true);
      setCount((v) => v + 1); // Trigger data reload
    }
  };

  // Clear date filters
  const clearDateFilter = () => {
    setFromDate("");
    setToDate("");
    setDateFilterApplied(false);
    setCount((v) => v + 1); // Trigger data reload
  };

  const buildUrlWithFilters = () => {
    let url = `/api/event/list?status=${selected}&count=${count}`;
    if (dateFilterApplied && fromDate && toDate) {
      url += `&fromDate=${fromDate}&toDate=${toDate}`;
    }
    return url;
  };

  const processData = (data) => {
    let filteredData = data.data;

    if (dateFilterApplied && fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      to.setHours(23, 59, 59);

      filteredData = data.data.filter((item) => {
        const startDate = new Date(item.startDate);
        return startDate >= from && startDate <= to;
      });

      // Update the full data object
      data = {
        ...data,
        data: filteredData,
      };
    }

    setList(filteredData);
    return data;
  };

  return (
    <div className="w-full mb-12 px-4">
      <Dialog
        open={openDetails}
        maxWidth={"lg"}
        fullWidth={true}
        onClose={() => setOpenDetails(false)}
      >
        <DialogTitle>Event Details</DialogTitle>
        <DialogContent>
          <div className={"flex flex-wrap items-center"}>
            <div className={"w-full md:w-3/12 lg:w-3/12"}>
              <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                Name
              </h3>
              <div className="mb-3 text-blueGray-600">{info?.name}</div>
            </div>
            <div className={"w-full md:w-3/12 lg:w-3/12"}>
              <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                Start Date
              </h3>
              <div className="mb-3 text-blueGray-600">
                {moment(info?.startDate).format("YYYY-MM-DD")}
              </div>
            </div>
            <div className={"w-full md:w-3/12 lg:w-3/12"}>
              <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                End Date
              </h3>
              <div className="mb-3 text-blueGray-600">
                {moment(info?.endDate).format("YYYY-MM-DD")}
              </div>
            </div>
            <div className={"w-full md:w-3/12 lg:w-3/12"}>
              <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                Client
              </h3>
              <div className="mb-3 text-blueGray-600">{info?.clientName}</div>
            </div>
            <div className={"w-full md:w-3/12 lg:w-3/12"}>
              <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                Participants
              </h3>
              <div className="mb-3 text-blueGray-600">{info?.participants}</div>
            </div>
            <div className={"w-full md:w-3/12 lg:w-3/12"}>
              <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                Budget
              </h3>
              <div className="mb-3 text-blueGray-600">
                {info?.budget?.toLocaleString()}
              </div>
            </div>
            <div className={"w-full md:w-3/12 lg:w-3/12"}>
              <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                Payment Status
              </h3>
              <div className="mb-3 text-blueGray-600">
                {info?.paymentStatus}
              </div>
            </div>
            <div className={"w-full md:w-3/12 lg:w-3/12"}>
              <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                Status
              </h3>
              <div className="mb-3 text-blueGray-600">{info?.status}</div>
            </div>
          </div>
          <div>
            <Typography variant={"h6"}>Assigned Staffs</Typography>
            <div>
              {staffs?.map((v) => (
                <Chip label={v.Resource?.names} />
              ))}
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/event/delete/${id}`}
      />
      <AddForm
        col={6}
        open={open > 0}
        maxWidth={"md"}
        onSuccess={onSuccess}
        setOpen={setOpen}
        url={open === 1 ? "/api/event/create" : `/api/event/update/${id}`}
        title={open === 1 ? "Create New Event" : "Edit Event"}
        mainFields={[
          {
            title: "",
            fields: [
              {
                name: "name",
                label: "Event name",
                value: value["name"],
                required: true,
                setValue: (val) => setValue0("name", val),
              },
              {
                name: "startDate",
                label: "Start Date",
                type: "date",
                value: value["startDate"],
                required: true,
                setValue: (val) => setValue0("startDate", val),
              },
              {
                name: "endDate",
                label: "End Date",
                type: "date",
                value: value["endDate"],
                required: true,
                setValue: (val) => setValue0("endDate", val),
              },
              {
                name: "clientName",
                label: "Client Name",
                type: "text",
                value: value["clientName"],
                required: true,
                setValue: (val) => setValue0("clientName", val),
              },
              {
                name: "participants",
                label: "Number of Participants",
                value: value["participants"],
                required: false,
                type: "number",
                setValue: (val) => setValue0("participants", val),
              },
              {
                name: "budget",
                label: "Budget",
                value: value["budget"],
                required: false,
                type: "number",
                setValue: (val) => setValue0("budget", val),
              },
              {
                name: "status",
                label: "Status",
                type: "select",
                value: value["status"],
                required: true,
                values: [
                  {
                    label: "Scheduled",
                    id: "scheduled",
                  },
                  {
                    label: "Open",
                    id: "open",
                  },
                  {
                    label: "Closed",
                    id: "closed",
                  },
                ],
                setValue: (val) => setValue0("status", val),
              },
              {
                name: "paymentStatus",
                label: "Payment Status",
                type: "select",
                value: value["paymentStatus"],
                values: [
                  {
                    label: "Payment Pending",
                    id: "pending",
                  },
                  {
                    label: "Invoice submitted",
                    id: "submitted",
                  },
                  {
                    label: "Paid",
                    id: "paid",
                  },
                ],
                setValue: (val) => setValue0("paymentStatus", val),
              },
              {
                name: "staffs",
                type: "multi-select-search",
                label: "Select event support staff",
                col: 12,
                checkCol: 4,
                required: true,
                value: value["staffs"],
                values: resources.data?.map((v) => ({
                  label: v.names,
                  value: v.id,
                })),
              },
            ],
          },
        ]}
      />
      <DatatableComponent
        order={location.state?.order}
        onRowClick={(data, { rowIndex }) => {
          const info = list[rowIndex];
          setInfo(info);
          setId(info.id);
          setOpenDetails(true);
        }}
        onAddNew={() => setOpen(1)}
        processData={processData}
        elevation={1}
        columns={columns}
        url={buildUrlWithFilters()}
        title={
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <span>
              Event Management{" "}
              {location.state?.status
                ? `(Status: ${location.state?.status})`
                : ""}
            </span>

            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <div className="md:w-full w-1/6 mb-2 xl:mb-0">
                <Paper
                  component="form"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "80%",
                    border: "none",
                    boxShadow: "none",
                  }}
                >
                  <label
                    style={{
                      minWidth: "80px",
                      maxWidth: "80px",
                      textAlign: "center",
                    }}
                    className="min-w-24 text-[#9295AB] text-ml px-3 py-1 font-light placeholder-blueGray-300 text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  >
                    FROM
                  </label>

                  <input
                    className="px-3 py-1 placeholder-blueGray-300 border-5 text-blueGray-600 bg-gray rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    type="date"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    max={toDate}
                  />
                </Paper>
              </div>

              <div className="md:w-full w-1/6 mb-2 xl:mb-0">
                <Paper
                  component="form"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "80%",
                    border: "none",
                    boxShadow: "none",
                  }}
                >
                  <label
                    style={{
                      minWidth: "80px",
                      maxWidth: "80px",
                      textAlign: "center",
                    }}
                    className="min-w-24 text-[#9295AB] text-ml px-3 py-1 font-light placeholder-blueGray-300 text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  >
                    TO
                  </label>

                  <input
                    className="px-3 py-1 placeholder-blueGray-300 border-5 text-blueGray-600 bg-gray rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    type="date"
                    value={toDate}
                    onChange={handleToDateChange}
                    min={fromDate}
                  />
                </Paper>
              </div>

              {dateFilterApplied && (
                <Button
                  variant="outlined"
                  size="small"
                  onClick={clearDateFilter}
                >
                  Clear
                </Button>
              )}
            </Box>
          </Box>
        }
      />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EventManagement);
